// JavaScript Document

var keydown_timeout;
var keydown_xhr;

function searchForm() {
	"use strict";
    $('form[name="search-form"] input').on('keydown',function(e){
        switch(true){
            case e.keyCode === 13: // ENTER
                if($('.quick-jump a.active').length>0){
                    var param = $('.quick-jump a.active').attr('href');
                    registerGAEvent('Search Form','submit',param);
                    window.location = param;
                    return false;
                }
                break;
        }
    });

    $('form[name="search-form"] input').on('keyup',function(e){

        switch(true){
            case e.keyCode === 38: // UP
                if($('.quick-jump a').length>0){
                    if($('.quick-jump a.active').length>0){
                        $('.quick-jump a.active').prev().addClass('active');
                        $('.quick-jump a.active:last').removeClass('active');
                    }else{
                        $('.quick-jump a:last').addClass('active');
                    }
                }
                break;
            case e.keyCode === 40: // DOWN
                if($('.quick-jump a').length>0){
                    if($('.quick-jump a.active').length>0){
                        $('.quick-jump a.active').next().addClass('active');
                        $('.quick-jump a.active:first').removeClass('active');
                    }else{
                        $('.quick-jump a:first').addClass('active');
                    }
                }
                break;
            default:
                var search_param = $('form[name="search-form"] input[name="q"]').val();

                if(search_param.length>3){

                    if(keydown_xhr!==null){
                        keydown_xhr.abort();
                        clearTimeout(keydown_timeout);
                    }

                    keydown_timeout = setTimeout(function(){

                        keydown_xhr = $.ajax({data: {
                            module:'products',
                            action:'get-search-keywords',
                            search_param :search_param
                        }, success: function (data) {
                            var m = [];
                            for(var i in data){
                                var u = URL + 'search-results/?q='+data[i]['text'];
                                m.push('<a href="'+u+'" class="list-group-item">'+data[i]['text']+'</a>');
                            }
                            $('.quick-jump').html(m.join(''));
                        }});
                    },200);
                }else{
                    $('.quick-jump').empty();
                }
        }
    });
    $('form[name="search-form"]').validate({

        submitHandler: function () {



            if(keydown_xhr!==null){
                keydown_xhr.abort();
                clearTimeout(keydown_timeout);
            }

            var search_param =$('form[name="search-form"] input[name="q"]').val();

            $('.quick-jump').empty();

            registerGAEvent('Search Form','submit',search_param);

            window.location=URL + 'search-results/?q='+search_param;
            return false;
        }
    });
}

function contactForm() {
	
    $.ajax({
        url: 'https://www.google.com/recaptcha/api.js',
        dataType: "script"
    });

    $('form[name="contact-form"]').validate({

        submitHandler: function () {
            $.ajax({data: $('form[name="contact-form"]').serialize(), success: function (data) {
                if (data.status == 'ok') {

                    ga('send', 'pageview', '/contact-success.html');

                    form_submit_response('form[name="contact-form"]', 'success', data.message, true);
                } else if (data.status == 'error') {
                    form_submit_response('form[name="contact-form"]', 'error', data.error);
                } else {
                    form_submit_response('form[name="contact-form"]', 'error', 'An unknown error occurred. Please try again later');
                }
            }});
        }
    });
}

function referForm() {
	"use strict";
    $('form[name="refer-form"]').validate({

        submitHandler: function () {
            $.ajax({data: $('form[name="refer-form"]').serialize(), success: function (data) {
                if (data.status === 'ok' && data.redirect) {
                    window.location = data.redirect;
                } else if (data.status === 'error') {
                    form_submit_response('form[name="contact-form"]', 'error', data.error);
                } else {
                    form_submit_response('form[name="contact-form"]', 'error', 'An unknown error occurred. Please try again later');
                }
            }});
        }
    });
}
function updateDetailsForm() {
	"use strict";
    $('form[name="update-details-form"]').validate({
        submitHandler: function () {
            $.ajax({data: $('form[name="update-details-form"]').serialize(), success: function (data) {
                if (data.status === 'ok') {
//                    $('#modal').modal('hide');
                } else if (data.status === 'error') {
                    form_submit_response('form[name="update-details-form"]', 'error', data.error);
                } else {
                    form_submit_response('form[name="update-details-form"]', 'error', 'An unknown error occurred. Please try again later');
                }
            }});
        }
    });
}
function addressForm() {
	"use strict";
    $('form[name="address-form"]').validate({
        submitHandler: function () {
            $.ajax({data: $('form[name="address-form"]').serialize(), success: function (data) {
                if (data.status === 'ok') {
                    form_submit_response('form[name="address-form"]', 'success', data.message, true);
                } else if (data.status === 'error') {
                    form_submit_response('form[name="address-form"]', 'error', data.error);
                } else {
                    form_submit_response('form[name="address-form"]', 'error', 'An unknown error occurred. Please try again later');
                }
            }});
        }
    });
}
function deleteMessagesForm() {
	"use strict";
    $(document).on('submit','form[name="delete_messages_form"]',function(){
        var the_form = $(this);
        $.ajax({data: the_form.serialize(), success: function (data) {
            if (data.status === 'ok') {

                if(data.total === 0){
                    $('.favorites-counter').removeClass('label-danger').addClass('label-default');
                }else{
                    $('.favorites-counter').addClass('label-danger').removeClass('label-default');
                }
                $('.favorites-counter').html(data.total);
                form_submit_response('#messages_product_view', 'success', data.message,true);

            } else if (data.status === 'error') {
                form_submit_response('#messages_product_view', 'error', data.error);
            } else {
                form_submit_response('#messages_product_view', 'error', 'An unknown error occurred. Please try again later');
            }


        }});

        return false;
    });
}


function debug(msg,append){
	"use strict";
    if($body.find('#debugger').length === 0){
        $body.prepend(
            '<div id="debugger" class="card blue-grey darken-1" style="position: fixed;z-index:9999;top:10px;left:10px;right:10px;max-height:200px;overflow: auto">' +
                '<a href="#" onclick="$(\'#debugger\').remove();return false;" style="position: absolute;z-index:999;top:10px;right:10px;overflow: auto"><i class="fa fa-times"></i></a>' +
                '<div class="card-content"></div>' +
                '</div>'
        );
    }

    if(append){
        $('#debugger .card-content').append('<p>'+JSON.stringify(msg)+'</p>');
    }else{
        $('#debugger .card-content').html('<p>'+JSON.stringify(msg)+'</p>');
    }


}
function parseQuery(str){
	"use strict";
    if(typeof str !== "string" || str.length === 0) {
		return {};
	}
    var s = str.split("&");
    var s_length = s.length;
    var bit, query = {}, first, second;
    for(var i = 0; i < s_length; i++)
    {
        bit = s[i].split("=");
        first = decodeURIComponent(bit[0]);
        if(first.length === 0){continue;} 
        second = decodeURIComponent(bit[1]);
        if(typeof query[first] === "undefined") {
			query[first] = second;
		}else if(query[first] instanceof Array) {
			query[first].push(second);
		}else {
			query[first] = [query[first], second];
		}
    }
    return query;
}


function registerForm(target) {
	"use strict";
	$('#newsletter_reg_modal').click(function(){
		var this_ckeckbox = $(this);
		if(this_ckeckbox.hasClass('checked')){
			this_ckeckbox.removeClass('checked');
			this_ckeckbox.removeAttr('checked');			
			$('.register-modal input[name="newsletter"]').attr('value', '0');
		}else{
			this_ckeckbox.attr('checked','checked');
			this_ckeckbox.addClass('checked');
			$('.register-modal input[name="newsletter"]').attr('value', '1');
		}
	});
	
	
	$(target).validate({
        rules: {
            'email': {
                required: true,
                email: true
            },
            'password': {
                required: true
            }
        },
        messages: {
            'email': 'Required',
            'password': 'Required'
        },

        submitHandler: function () {
            $('body').prepend('<div class="loading blocking text-center"><span>PROCESSING REQUEST</span></div>');
            $.ajax({data: $(target).serialize(), success: function (data) {
                $('.loading').remove();
                if (data.status === 'ok') {

                    trackGoal('opt_in');

                    if(registerTimeout!==null){
                        clearTimeout(registerTimeout);
                    }

                    if(data.redirect){
                        //form_submit_response(target, 'success', data.message);
                        //setTimeout(function(){
                            window.location = data.redirect;
                        //},3000);

                    }else{
                        form_submit_response(target, 'success', data.message, true);
                    }

                } else if (data.status === 'error') {
                    if(data.error_code === 100){
                        openAjaxModal(URL  + 'ajax/customer:login-sso/'+$(target).find('input[name="email"]').val()+'/');
                    }else{
                        form_submit_response(target, 'error', data.error);
                    }
                } else {
                    form_submit_response(target, 'error', 'An unknown error occurred. Please try again later');
                }
            }});
        }
    });
}

function updateAccountForm() {
	"use strict";
    $('form[name="my_account_form"]').addClass('ready');
    $('form[name="my_account_form"]').validate({
        rules: {
            'name': 'required',
            'surname': 'required',
            'username': 'required',
            'password': {
                minlength: 5
            },
            'password_verify': {
                minlength: 5,
                equalTo: "#password"
            },
            'captcha_code': 'required'
        },
        messages: {
            'name': 'Required',
            'surname': 'Required',
            'username': 'Required',
            'password': {
                minlength: "! Must be at least 5 characters long"
            },
            'password_verify': {
                required: 'Required',
                minlength: "! Must be at least 5 characters long"
            },
            'captcha_code': 'Required'
        },
        submitHandler: function () {
            $.ajax({data: $('form[name="my_account_form"]').serialize(), success: function (data) {
                if (data.status === 'ok') {
                    form_submit_response('form[name="my_account_form"]', 'success', 'Account details have been succesfully updated', true);
                } else if (data.status === 'error') {
                    form_submit_response('form[name="my_account_form"]', 'error', data.error);
                } else {
                    form_submit_response('form[name="my_account_form"]', 'error', 'An unknown error occurred. Please try again later');
                }
            }});
        }
    });
}
function fdaVarianceModalForm() {
	"use strict";
    $('form[name="fda_variance_form"]').addClass('ready');
    $('form[name="fda_variance_form"]').validate({
        rules: {
            'fda_variance': 'required'
        },
        messages: {
            'fda_variance': 'Required'
        },
        submitHandler: function () {
            $.ajax({data: $('form[name="fda_variance_form"]').serialize(), success: function (data) {
                if (data.status === 'ok') {
                    form_submit_response('form[name="fda_variance_form"]', 'success', 'Account details have been successfully updated');
                    $('#fda-confirmation-popup').closeModal();
                } else if (data.status === 'error') {
                    form_submit_response('form[name="fda_variance_form"]', 'error', data.error);
                } else {
                    form_submit_response('form[name="fda_variance_form"]', 'error', 'An unknown error occurred. Please try again later');
                }
            }});
        }
    });
}
function getHash() {
	"use strict";
    var hash = window.location.hash;
    return hash.substring(2); // remove #!
}

function loginForm() {
	"use strict";
    $('form[name="login_form"]').on('keydown',function(e){
        switch(true){
            case e.keyCode === 13: // ENTER
                $('form[name="login_form"]').submit();
                break;
        }
    });

    $('form[name="login_form"]').addClass('ready');
    $('form[name="login_form"]').validate({
        rules: {
            'email': 'required',
            'password': 'required'
        },
        messages: {
            'email': 'Required',
            'password': 'Required'
        },
        submitHandler: function () {
            $.ajax({data: $('form[name="login_form"]').serialize(), success: function (data) {
                if (data.status === 'ok'  && typeof(data.redirect) !== 'undefined') {
                    var hash = getHash();
                    //window.location.reload();
                    window.location = data.redirect;

                    if (hash.substring(0, 9) === 'order_id=') {
                        window.location.reload();
                    } else {
                        window.location = (data.redirect || URL);
                    }
                    if(registerTimeout && registerTimeout!==null){
                        clearTimeout(registerTimeout);
                    }
                }else if (data.status === 'ok'){
                    window.location.reload();
                    if(registerTimeout && registerTimeout!==null){
                        clearTimeout(registerTimeout);
                    }
                }else if (data.status === 'error') {
                    if (typeof(data.callback) !== 'undefined') {
                        var email = $('form[name="login_form"] input[name="email"]').val();
                        eval(data.callback + '("' + data.error + '","' + email + '")');
                    } else {
                        form_submit_response('form[name="login_form"]', 'error', data.error);
                    }
                } else {
                    form_submit_response('form[name="login_form"]', 'error', 'An unknown error occurred. Please try again later');
                }

            }});
        }
    });
}

function resend_activation_email(message, email) {
	"use strict";
    message += '\nResend activation email?';
    var r = confirm(message);
    if (r === true) {
        $.ajax({data: {module: 'customers', 'action': 'send-activation-email', email: email}, success: function (data) {
            if (data.status === 'ok') {
                form_submit_response('', 'success', 'Activation email succesfully sent', true);
            } else if (data.status === 'error') {
                form_submit_response('form[name="login_form"]', 'error', data.error);
            } else {
                form_submit_response('form[name="login_form"]', 'error', 'An unknown error occurred. Please try again later');
            }

        }});
    }


}

function forgotPasswordForm() {
	"use strict";
    $('form[name="forgot_password_form"]').addClass('ready');
    $('form[name="forgot_password_form"]').validate({
        rules: {
            'email': 'required'
        },
        messages: {
            'email': 'Required'
        },
        submitHandler: function () {
            $('body').prepend('<div class="loading blocking text-center"><span>VALIDATING REQUEST</span></div>');

            $.ajax({data: $('form[name="forgot_password_form"]').serialize(), success: function (data) {
                $('.loading').remove();
                if (data.status === 'ok') {
                    $('form[name="forgot_password_form"] .form-submitted').removeClass('hide');
                    $('form[name="forgot_password_form"] input:text').data('email',$('form[name="forgot_password_form"] input:text').val());
                    $('form[name="forgot_password_form"] input:text').val('');
                    $('form[name="forgot_password_form"] input:text').closest('.row').hide();
                } else if (data.status === 'error') {
                    form_submit_response('form[name="forgot_password_form"]', 'error', data.error);
                } else {
                    form_submit_response('form[name="forgot_password_form"]', 'error', 'An unknown error occurred. Please try again later');
                }

            }});
        }
    });
}

function notifyForgotPasswordIssue(){
	"use strict";
    $('form[name="forgot_password_form"]').append('<div class="processing blocking"></div>');
    $('form[name="forgot_password_form"] .form-submitted').addClass('hide');
    $.ajax({data: {
        module  : 'customers',
        action  : 'notify-forgot-password-issue',
        email   : $('form[name="forgot_password_form"] input[name="email"]').val()
    }, success: function (data) {
        $('form[name="forgot_password_form"] .processing').remove();
        if (data.status === 'ok') {
            $('form[name="forgot_password_form"] .link-clicked').removeClass('hide');
        } else if (data.status === 'error') {
            form_submit_response('form[name="forgot_password_form"]', 'error', data.error);
        } else {
            form_submit_response('form[name="forgot_password_form"]', 'error', 'An unknown error occurred. Please try again later');
        }

    }});
}

function resetPasswordForm() {
	"use strict";
    $('form[name="reset_password_form"]').addClass('ready');
    $('form[name="reset_password_form"]').validate({
        rules: {
            password: {
                required: true,
                minlength: 6
            },
            password_verify: {
                minlength: 6,
                equalTo: "#password"
            },
            email: {
                required: true,
                email: true
            }
        },
        messages: {
            'email': 'Required',
            'password': 'Required',
            'password_verify': 'Required'
        },
        submitHandler: function () {
            $('body').prepend('<div class="loading blocking text-center"><span>RESETTING PASSWORD</span></div>');

            $.ajax({data: $('form[name="reset_password_form"]').serialize(), success: function (data) {
                $('.loading').remove();
                if (data.status === 'ok') {

                    var email = $('form[name="reset_password_form"] input[name="email"]').val();
                    setTimeout(function(){
                        window.location = URL + 'home/?email='+email;
                    },5000);
                    $('form[name="reset_password_form"] input:text').val('');
                    $('form[name="reset_password_form"] input:password').val('');
                    form_submit_response('form[name="reset_password_form"]', 'success', data.message);
                } else if (data.status === 'error') {
                    form_submit_response('form[name="reset_password_form"]', 'error', data.error);
                } else {
                    form_submit_response('form[name="reset_password_form"]', 'error', 'An unknown error occurred. Please try again later');
                }

            }});
        }
    });
}

function form_submit_response(target, type, message, r) {
	"use strict";
    /*var redirect = r || false;
    $('#growls').empty();
    if (type == 'error') {
        $.growl.error({ duration:6000,title:'',message: message, location: 'tr',size:'large'  });
    } else if (type == 'warning') {
        $.growl.warning({ duration:6000,title:'',message: message, location: 'tr',size:'large'   });
    } else if (type == 'success') {
        $.growl.notice({ duration:6000,title: '', message: message, location: 'tr',size:'large'  });
    } else {
        $.growl({duration:6000,title: '', message: message, location: 'tr',size:'large'  });
    }
    if (redirect) {
        setTimeout(function () {
            window.location.reload();
        }, 2000);
    }*/
	alert(message);
}

function initNewsletterForm() {
	"use strict";
	$('form[name="newsletter-form"] #newsletter_reg').click(function(){
		var this_ckeckbox = $(this);
		if(this_ckeckbox.hasClass('checked')){
			this_ckeckbox.removeClass('checked');
			this_ckeckbox.removeAttr('checked');			
			$('form[name="newsletter-form"] input[name="newsletter"]').attr('value', '0');
		}else{
			this_ckeckbox.attr('checked','checked');
			this_ckeckbox.addClass('checked');
			$('form[name="newsletter-form"] input[name="newsletter"]').attr('value', '1');
		}
	});
    $('form[name="newsletter-form"]').validate({
        submitHandler: function () {
            $.ajax({data: $('form[name="newsletter-form"]').serialize(), success: function (data) {
                if (data.status === "ok") {
                   form_submit_response('form[name="newsletter-form"]', 'success', data.message);
                } else if (data.status === 'error') {
                    form_submit_response('form[name="newsletter-form"]', 'error', data.error);
                } else {
                    form_submit_response('form[name="newsletter-form"]', 'error', 'An unknown error occurred. Please try again later');
                }
            }});
        }
    });
}
function reviewForm(){
	"use strict";
    $('form[name="review-form"]').validate({
        submitHandler: function() {
            $.ajax({data:$('form[name="review-form"]').serialize(),success:function(data){
                if(data.status === 'ok'){
                    form_submit_response('form[name="review-form"]' , 'success' ,data.message,true);
                }else if(data.status === 'error') {
                    form_submit_response('form[name="review-form"] ', 'error' ,data.error);
                }else{
                    form_submit_response('form[name="review-form"]','error','An unknown error occurred. Please try again later');
                }
            }});
        }
    });
}
$(function(){
	"use strict";
    $.validator.setDefaults({
        debug: false,
        errorPlacement: function(error) {
            error.hide();
        },
        highlight: function (element, errorClass, validClass) {

            if($(element).is(':radio')){
                $(element).parent().parent().find('.form-control-feedback').remove();
                $(element).parent().parent().append('<span class=" form-control-feedback" style="right:-20px"><i class="fa fa-times"></i></span>');
                $(element).parent().parent().addClass('has-error has-feedback');
            }else{
                $(element).addClass('invalid').removeClass('valid');
            }

        },
        unhighlight: function (element, errorClass, validClass) {
            $(element).removeClass('invalid').addClass('valid');
        }
    });
});
